export enum RolesSlugs {
  Superadmin = "backoffice.superadmin",
}
